if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (cartNotification) {
          cartNotification.setActiveElement(this.openedBy);
        }

        this.modalContent.innerHTML = '';

        if (preventFocus) {
          this.openedBy = null;
        }

        super.hide();
      }

      show(opener) {
        const productUrl = opener?.getAttribute('data-product-url');
        const opensVariantDialog =
          opener?.getAttribute('aria-haspopup') === 'dialog';

        /*
         * Produkter med knappen "Välj alternativ"
         * skickas direkt till produktsidan.
         *
         * "Lägg till i varukorg" påverkas inte eftersom den
         * knappen inte öppnar quick-add-modal.
         */
        if (opensVariantDialog && productUrl) {
          window.location.assign(productUrl);
          return;
        }

        opener.setAttribute('aria-disabled', 'true');
        opener.classList.add('loading');

        const loadingSpinner = opener.querySelector(
          '.loading-overlay__spinner'
        );

        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        }

        fetch(productUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Kunde inte hämta produkten: ${response.status}`
              );
            }

            return response.text();
          })
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );

            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]'
            );

            if (!this.productElement) {
              throw new Error(
                'Kunde inte hitta produktsektionen på produktsidan.'
              );
            }

            this.preventDuplicatedIDs();
            this.removeDOMElements();

            const mediaGallery =
              this.productElement.querySelector('media-gallery');

            if (mediaGallery) {
              mediaGallery.dataset.disablePrepend = 'false';
            }

            this.setInnerHTML(
              this.modalContent,
              this.productElement.innerHTML
            );

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();

            super.show(opener);
          })
          .catch((error) => {
            console.error('Quick add-fel:', error);

            /*
             * Reservlösning: öppna produktsidan om modalen
             * av någon anledning inte kan laddas.
             */
            if (productUrl) {
              window.location.assign(productUrl);
            }
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');

            if (loadingSpinner) {
              loadingSpinner.classList.add('hidden');
            }
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        /*
         * Återskapar script-taggarna så att de kan köras.
         * Script körs normalt inte när de läggs in med innerHTML.
         */
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');

          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(
              attribute.name,
              attribute.value
            );
          });

          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          );

          oldScriptTag.parentNode.replaceChild(
            newScriptTag,
            oldScriptTag
          );
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector(
          'variant-radios, variant-selects'
        );

        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability =
          this.productElement.querySelector('pickup-availability');

        if (pickupAvailability) {
          pickupAvailability.remove();
        }

        const productModal =
          this.productElement.querySelector('product-modal');

        if (productModal) {
          productModal.remove();
        }

        const stickyAtc =
          this.productElement.querySelector('sticky-atc');

        if (stickyAtc) {
          stickyAtc.remove();
        }

        const modalDialogs =
          this.productElement.querySelectorAll('modal-dialog');

        modalDialogs.forEach((modal) => {
          modal.remove();
        });
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;

        if (!sectionId) return;

        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );

        this.productElement
          .querySelectorAll(
            'variant-selects, variant-radios, product-info'
          )
          .forEach((element) => {
            element.dataset.originalSection = sectionId;
          });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );

        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');

        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((item) => {
            item.setAttribute('role', 'presentation');
          });
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');

        if (!product) return;

        const desktopColumns =
          product.classList.contains('product--columns');

        if (!desktopColumns) return;

        const mediaImages =
          product.querySelectorAll('.product__media img');

        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, ' +
          '(min-width: 750px) calc((100vw - 11.5rem) / 2), ' +
          'calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace(
            '715px',
            '605px'
          );
        } else if (
          product.classList.contains('product--small')
        ) {
          mediaImageSizes = mediaImageSizes.replace(
            '715px',
            '495px'
          );
        }

        mediaImages.forEach((image) => {
          image.setAttribute('sizes', mediaImageSizes);
        });
      }
    }
  );
}